var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"spinner-inside"},[_c('div',{staticClass:"spinner-box-rotate"},[_c('div',{staticClass:"spinner-box-scale"},[_c('div',{staticClass:"spinner-circle spinner-circle-light-blue"}),_c('div',{staticClass:"spinner-circle spinner-circle-blue"}),_c('div',{staticClass:"spinner-circle spinner-circle-green"})])])])])
}]

export { render, staticRenderFns }